import { setDisplayName, wrapDisplayName } from 'recompose'

/**
 * Simple helper for all other HOCs.
 * Sets wrapped displayName.
 *
 * Example:
 * - setWrapDisplayName(Component, 'someHoc')
 * Sets 'someHoc(Component)' as displayName
 */
export const setWrapDisplayName = (WrappedComponent, displayName) =>
  setDisplayName(wrapDisplayName(WrappedComponent, displayName))
